/* The supplement facts popup (snippets/shto-supplement-facts.liquid). A button with data-shto-facts-open="<id>" opens the
   dialog with that id as a modal; the X, a click on the dark veil around the card, and Escape close it, and focus goes back
   to the button. While it is open the page behind it doesn't scroll. Listens on the document once, so any number of
   sections can use it. Never touches the address. */
(function () {
  if (window.ShtoFacts) return;
  window.ShtoFacts = true;

  var opener = null;
  var savedOverflow = '';

  function open(dialog, button) {
    if (dialog.open) return;
    opener = button || null;
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var close = dialog.querySelector('[data-shto-facts-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function close(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else { dialog.removeAttribute('open'); afterClose(); }
  }

  function afterClose() {
    document.documentElement.style.overflow = savedOverflow;
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-shto-facts-open]');
    if (button) {
      var dialog = document.getElementById(button.getAttribute('data-shto-facts-open'));
      if (dialog) { event.preventDefault(); open(dialog, button); }
      return;
    }
    var openDialog = target.closest('dialog[data-shto-facts]');
    if (!openDialog) return;
    // The X, or the veil: the dialog covers the screen, so a click on it that isn't on the card is on the veil.
    if (target.closest('[data-shto-facts-close]') || target === openDialog) close(openDialog);
  });

  // Escape (the browser's own "cancel") and dialog.close() both end here.
  document.addEventListener('close', function (event) {
    if (event.target && event.target.matches && event.target.matches('dialog[data-shto-facts]')) afterClose();
  }, true);

  // A dialog without showModal (very old browsers) gets Escape from here.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var dialog = document.querySelector('dialog[data-shto-facts][open]');
    if (dialog && typeof dialog.showModal !== 'function') close(dialog);
  });
})();
